/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteServiceTypeComponent } from './delete-service-type.component';
import { FormsModule } from '@angular/forms';
import { AngularDraggableModule } from 'angular2-draggable';
import { RouterModule, Routes } from '@angular/router';
import { SysqueAlertModule } from '../../../../../../../shared/ui/src/lib/components/sysque-alert';

const routes: Routes = [{ path: 'dialog/delete-service-type-dialog', component: DeleteServiceTypeComponent }];

@NgModule({
  declarations: [DeleteServiceTypeComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularDraggableModule,
    SysqueAlertModule,
    RouterModule.forChild(routes)
  ],
  exports: [DeleteServiceTypeComponent]
})
export class DeleteServiceTypeModule { }